import axios from "axios";
import { useMutation } from "react-query";
import { END_POINT } from "config/environment";
import { IDeclineInvite } from "../types";

export const declineInvite = async (props: IDeclineInvite) => {
  const url = `${END_POINT.BASE_URL}/v1/decline-invite`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const data: any = {
    listing_invite_id: props.listing_invite_id,
    decline_reason: props.decline_reason,
  };

  const response = await axios.post(url, data, config);
  return response;
};

export const useDeclineInvite = () => {
  return useMutation(declineInvite);
};
